export default __webpack_public_path__ + "static/GEAwtarDWTC-Medium-5a1e326767e0cb179004ea8b4ef90dee.ttf";